export default {
  productsLeft: {
    en: '{count, plural, one {<span>#</span>&nbsp;product} other {<span>#</span>&nbsp;products}} left',
  },
  soldOut: {
    en: 'Product is&nbsp;<span>out of stock</span>&nbsp;:(',
  },
}
